import { render, staticRenderFns } from "./mp3Play.vue?vue&type=template&id=f123a4ec"
import script from "./mp3Play.vue?vue&type=script&lang=js"
export * from "./mp3Play.vue?vue&type=script&lang=js"
import style0 from "./mp3Play.vue?vue&type=style&index=0&id=f123a4ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports